import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    SAVE_ACTIVITY,
    PENDING_ACTIVITY,
    MARK_ATTENDANCE,
    ACCOUNT_LIST, ACCOUNT_BY_LEAD_ID
} from "./type";


// export const saveAccount = (data) => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.post,
//         data,
//         `${Config.valetAccountSave}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: SAVE,
//             payload: data.response,
//         });
//         return true;
//     }
// };
//
// export const accountList = (page = 1, searchKey = '', data=[{}]) => async (dispatch) => {
//     let urls = `${Config.baAccountList}?page=` + page
//
//     if(searchKey !== ''){
//         urls = urls+"&search_key="+searchKey
//     }
//     Object.keys(data[0]).map((val, i)=>{
//         urls+="&"+val+"="+data[0][val]
//     })
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         urls
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: ACCOUNT_LIST,
//             payload: data.response.data,
//         });
//         return true;
//     }
// };
//
// export const accountById = (id) => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.valetAccountById}?id=${id}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: ACCOUNT_BY_ID,
//             payload: data.response,
//         });
//         return true;
//     }
// };

export const saveActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.SaveActivityByModule}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

// export const getFilter = () => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.valetAccountFilter}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: ACCOUNT_FILTER,
//             payload: data.response,
//         });
//         return true;
//     }
// };

export const getPendingActivity = (moduleType, moduleName, accountId = '') => async (dispatch) => {
    if(accountId === -1){
        return false
    }
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.pendingActivityByModule}?account_id=${accountId}&module_type=${moduleType}&module_name=${moduleName}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const markAttendance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.attendanceByModule}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MARK_ATTENDANCE,
            payload: data.response,
        });
        return data.response;
    }
};